/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Routes from './routing/Routes'
import AppContext from './context/context'
import firebase from './firebace'
import env from '@beam-australia/react-env'

const App = () => {
  const [show, setShow] = useState(false)
  const [notification, setNotification] = useState({ title: '', body: '' })
  const [isTokenFound, setTokenFound] = useState(false)
  env()
  useEffect(() => {
    // const msg = firebase.messaging();
    // msg.getToken().then((data) => {
    //   console.log("ccc", data);
    // });
    // msg.onMessage((data) => {
    //   console.log("ccc", data);
    // });
    // msg.onBackgroundMessage((data) => {
    //   console.log("ccc", data);
    // });
  }, [])
  return (
    <AppContext>
      <Router>
        <Route component={Routes} />
      </Router>
    </AppContext>
  )
}

export default App
